<template>
  <div class="category-filter sm:w-3/4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
    <Category
      v-for="category in categories"
      :key="category.id"
      :label="category.name"
      :icon="getIconByCategoryName(category.name)"
      :active="filter.categories.indexOf(category.id) > -1"
      @select="onSelectCategory(category)" />
  </div>
</template>

<script>
import filterStore from '@/Store/filter'
import Category from './Category'

export default {
  name: 'CategoryFilter',
  components: { Category },

  data () {
    return {
      filter: filterStore.state
    }
  },

  computed: {
    categories() {
      return this.$page.props.categories
    }
  },

  methods: {
    onSelectCategory(category) {
      if (this.filter.categories.indexOf(category.id) > -1) {
        filterStore.removeCategoryAction(category)
      } else {
        filterStore.setCategoryAction(category)
      }
    },

    getIconByCategoryName(name) {
      let iconName

      switch (name) {
        case 'Gebäck':
          iconName = 'gebaeck'
          break;
        case 'Brot':
          iconName = 'brot'
          break;
        case 'Brötchen':
          iconName = 'broetchen'
          break;
        case 'Snack':
          iconName = 'snack'
          break;
        case 'Feingebäck':
          iconName = 'gebaeck'
          break;
        case 'Kuchen':
          iconName = 'kuchen'
          break;
        case 'Bioselfies':
          iconName = 'bioselfies'
          break;
        case 'Bio Selfies':
          iconName = 'bioselfies'
          break;
        case 'Non-Food':
          iconName = 'non-food'
          break;
        case 'Herbst':
          iconName = 'herbs'
          break;
        case 'Karneval':
          iconName = 'karneval'
          break;
        case 'Ostern':
          iconName = 'ostern'
          break;
        case 'Grillen':
          iconName = 'grillen'
          break;
        case 'Ofensortiment':
          iconName = 'ofensortiment'
          break;
        case 'Weihnachten':
          iconName = 'weihnachten'
          break;
        default:
          break;
      }

      return iconName
    }
  }
}
</script>

<style scoped>
.category-filter {
  background-color: #d9d6d34d;
}
</style>
